export default __webpack_public_path__ + "static/media/linkedin.3ec38fd3.svg";